var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AnablueSidebar',{attrs:{"items":_vm.sidebarTabs,"minimize":_vm.minimize,"translations":_vm.translationsObject},on:{"update:minimize":_vm.setMinimize}})
}
var staticRenderFns = []

export { render, staticRenderFns }